import { Pipe, PipeTransform } from '@angular/core';

const nonResizableClassesWithPanel = 'col-6 order-2';
const nonResizableClassesWithoutPanel = 'col-9';

@Pipe({
  name: 'mainColumnLayout',
  pure: true
})
export class MainColumnLayoutPipe implements PipeTransform {
  transform(resizableMode: boolean, showInfoPanel: boolean): string {
    const classes: string[] = [];

    if (showInfoPanel) {
      classes.push('-showInfoPanel');
    }

    if (resizableMode) {
      classes.push('col');
    } else {
      classes.push(showInfoPanel ? nonResizableClassesWithPanel : nonResizableClassesWithoutPanel);
    }

    return classes.join(' ');
  }
}
